import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN = '[IncidentsModul] PostIncidentVorlageAnlegenAdmin laden';
export const POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_AUSFUEHREN = '[IncidentsModul] PostIncidentVorlageAnlegenAdmin ausführen';
export const POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_ERFOLGREICH = '[IncidentsModul] PostIncidentVorlageAnlegenAdmin laden erfolgreich';
export const POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_FEHLER = '[IncidentsModul] PostIncidentVorlageAnlegenAdmin Ladefehler';
export const POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] PostIncidentVorlageAnlegenAdmin nicht ausgeführt (evtl. Offline)';


export class PostIncidentVorlageAnlegenAdminAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN;
        constructor(public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAnlegenAdminAusfuehrenAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_AUSFUEHREN;
        constructor(public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAnlegenAdminErfolgreichAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.IncidentVorlageIdentifier, public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAnlegenAdminFehlerAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_FEHLER;
        constructor(public payload: any, public incidentVorlageDatenRequest: api.IncidentVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostIncidentVorlageAnlegenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_INCIDENT_VORLAGE_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsCommandIncidentVorlageAnlegenAdminActions =
    PostIncidentVorlageAnlegenAdminAction
    | PostIncidentVorlageAnlegenAdminAusfuehrenAction
    | PostIncidentVorlageAnlegenAdminErfolgreichAction
    | PostIncidentVorlageAnlegenAdminFehlerAction
    | PostIncidentVorlageAnlegenAdminNichtAusgefuehrtAction
    ;
